import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MODAL_EXPORT_TO_SHEETS } from '../../util/enums/EnumModals';
import { CopyBox } from '../CopyBox';

class ModalExportToSheets extends Component {
  static modalType() {
    return MODAL_EXPORT_TO_SHEETS;
  }

  static reducer(modals) {
    return modals.exportToSheetsModal;
  }

  static title() {
    return (
      <span>
        <span
          className="glyphicon glyphicon-share-alt margin-right-10"
          aria-hidden="true"
        />
        Export to Google Sheets
      </span>
    );
  }

  static includeSaveButton() {
    return false;
  }

  render() {
    const { state, loadedView } = this.props;

    const changeLimitsButton = (
      <small>
        <b>To change limits</b>, ask your admin.
      </small>
    );

    const randomSeed = Math.round(Math.random() * 100) + 1;

    return (
      <div className="margin-10">
        <div className="margin-left-20 margin-right-20">
          <label>
            Copy the following link and paste it into a cell in Google Sheets:
          </label>
          <br />
          <br />
          <CopyBox
            value={`=importdata("${loadedView.downloadPrefix()}1d/${loadedView.downloadSuffix()}.csv?maxWaitSeconds=20&seed=${randomSeed}")`}
          />
          <br />
          <small className="pull-right faint">
            Google Sheets will automatically update your results every hour.
          </small>
          <div className="text-align-right subtle">
            <br />
            <br />
            <br />
            <small>Max export size: {state.rowLimit} rows</small>
            <br />
            <small>Query timeout: {state.queryTimeoutSeconds} seconds</small>
            <br />
            <br />
            {changeLimitsButton}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loadedView: state.views.lastLoadedView,
    isAdmin: state.datasource.isAdmin,
  };
};

export default connect(mapStateToProps)(ModalExportToSheets);
